import React from "react";
import classnames from "classnames";
import CarouselCard from "./CarouselCard";
import { Swiper as SwiperWrapper, SwiperSlide } from "swiper/react/swiper-react";
import Swiper, { Navigation, Pagination } from "swiper";
import { Container } from "reactstrap";
import useApi from "../../hooks/useApi";
import qs from "query-string";

import "swiper/swiper-bundle.css";

import styles from "./Carousel.module.scss";

Swiper.use([Navigation, Pagination]);

interface CarouselProps {
  id: string;
  headline?: string;
  variant?: "homepage" | "what-we-do";
  formikContext?: any;
  publications?: [] | null;
  experienceTags?: [] | null;
}

const Carousel: React.FC<CarouselProps> = ({
  id,
  variant = "homepage",
  headline,
  experienceTags = [],
  ...props
}) => {
  const isHomepage = variant === "homepage";
  const filters: any = { limit: 5 };
  if (experienceTags && experienceTags.length)
    filters.experience_tags = experienceTags.map((tag: any) => tag.slug);
  const filterQueryString = qs.stringify(filters, { arrayFormat: "bracket" });

  // Get posts from API
  const manuallySelect = props.publications && props.publications.length;
  const [{ data = {}, loading }] = useApi(`get/publications?${filterQueryString}`, {
    manual: manuallySelect,
  });
  const publications = (manuallySelect ? props.publications : data.publications) || [];

  if (!publications.length) return null;

  const settings = {
    slidesPerView: isHomepage ? 1 : 2,
    spaceBetween: 9,
    modules: [Navigation, Pagination],
    navigation: {
      prevEl: `.swiper-prev-${id}`,
      nextEl: `.swiper-next-${id}`,
      disabledClass: `${styles.swiperHidden}`,
    },
    pagination: { clickable: true },
    breakpoints: {
      768: {
        slidesPerView: isHomepage ? 1 : 2,
      },
      0: {
        slidesPerView: 1.1,
      },
    },
  };
  return (
    <div>
      <div className={classnames(styles.titleContainer, { [styles.dark]: isHomepage })}>
        <h3 className={styles.title}>{headline}</h3>
        <div className={styles.carouselButtonsContainer}>
          <button
            aria-label="Swipe previous carousel"
            className={`swiper-prev swiper-prev-${id} ${styles.swiperPrev}`}
          >
            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.2002 2L7.15895 7.95875L1.2002 13.9175" fill="white" />
              <path
                d="M1.2002 2L7.15895 7.95875L1.2002 13.9175"
                stroke="#222221"
                stroke-width="1.5"
                stroke-linecap="square"
              />
            </svg>
          </button>
          <button
            aria-label="Swipe next carousel"
            className={`swiper-next swiper-next-${id} ${styles.swiperNext}`}
          >
            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.2002 2L7.15895 7.95875L1.2002 13.9175" fill="white" />
              <path
                d="M1.2002 2L7.15895 7.95875L1.2002 13.9175"
                stroke="#222221"
                stroke-width="1.5"
                stroke-linecap="square"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className={styles.overflowWrapper}>
        <Container className={styles["edo-carousel-wrapper"] + ` ${styles[variant]}`}>
          <SwiperWrapper {...settings} className={styles["edo-carousel"]}>
            {publications.map((content: any, index: any) => (
              <SwiperSlide key={index}>
                <CarouselCard slideIndex={index} variant={variant} data={content} />
              </SwiperSlide>
            ))}
          </SwiperWrapper>
        </Container>
      </div>
    </div>
  );
};

export default Carousel;
